import React, { useEffect } from 'react'

import {
  BodyText,
  Button,
  HeadingLarge,
  Label,
  LayoutContainer as Container,
  ModalButtons,
  PayLaterInStoreInfo,
} from '@pb/components'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import ConditionalRedirecter from 'App/ConditionalRedirecter'
import { ACCOUNT_ROUTES } from 'App/constants'
import appSelectors from 'App/duck/selectors'
import SettingsNotification from 'features/account/settings/components/SettingsOverview/SettingsNotification'

import { operationFetchStoreActivationInfo } from '../../duck/operations'
import selectors from '../../duck/selectors'
import PrivacyPolicyModal from '../PrivacyPolicyModal'
import styles from './StoreActivationInfo.scss'

const StoreActivationInfo: React.FC = () => {
  const history = useHistory()
  const location: any = useLocation()
  const dispatch = useDispatch()
  const privacyPolicyLink = useSelector(selectors.getStoreActivationInfo)
  const isPayLaterActivationEnabled = useSelector(appSelectors.getIsPayLaterActivationEnabled)
  const isPayLaterAllowed = useSelector(appSelectors.getIsPayLaterActivationAllowed)
  const isPayLaterCustomer = useSelector(appSelectors.getIsPayLaterActivatedForUser)

  useEffect(() => {
    dispatch(operationFetchStoreActivationInfo())
  }, [])

  const navigateToStoreActivation = (): any => {
    history.push(ACCOUNT_ROUTES.PayLaterStoreActivation.path)
  }

  const leaveStoreActivation = (): any => {
    history.push(
      location?.state?.isReactivationFlow
        ? ACCOUNT_ROUTES.Settings.path
        : ACCOUNT_ROUTES.AccountOverview.path,
    )
  }

  return (
    <ConditionalRedirecter
      shouldRedirect={!isPayLaterActivationEnabled || !isPayLaterAllowed || isPayLaterCustomer}
      fallbackRoute={ACCOUNT_ROUTES.AccountOverview.path}
    >
      <Container Tag="main" className={styles.container}>
        <SettingsNotification />
        <HeadingLarge Tag="h1">
          <Label copyKey="storeactivation.paylater.heading1" />
        </HeadingLarge>
        <BodyText>
          <Label
            copyKey={
              location?.state?.isReactivationFlow
                ? 'storeactivation.paylater.inforeactivation'
                : 'storeactivation.paylater.info'
            }
          />
        </BodyText>
        <PayLaterInStoreInfo
          containerClassName={styles.payLaterInStoreInfo}
          titleCopyKey="storeactivation.paylater.heading2"
          showAppStoreIcons={false}
        />
        {privacyPolicyLink && <PrivacyPolicyModal link={privacyPolicyLink} />}
        <ModalButtons fullWidth>
          <Button onClick={navigateToStoreActivation}>
            <Label copyKey="storeactivation.paylater.yes" />
          </Button>
          <Button secondary onClick={leaveStoreActivation}>
            <Label
              copyKey={
                location?.state?.isReactivationFlow
                  ? 'storeactivation.paylater.back'
                  : 'storeactivation.paylater.maybelater'
              }
            />
          </Button>
        </ModalButtons>
      </Container>
    </ConditionalRedirecter>
  )
}

export default StoreActivationInfo
